<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">Species</h2>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col cols="12" sm="3" offset-sm="1">
                            <v-checkbox
                                label="Active Only"
                                v-model="activeOnly"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" offset-sm="1">
                        </v-col>
                        <v-col cols="12" sm="2" offset-sm="1">
                            <v-btn
                                v-if="!auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="editSpecies({ Active: true })"
                            >
                                Add
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers"
                                :items="species"
                                :loading="loading"
                                :sort-by.sync="pagination.sortBy"
                                :sort-desc.sync="pagination.sortDesc"
                                :items-per-page.sync="pagination.rowsPerPage"
                                :page.sync="pagination.page"
                                :footer-props="footerProps"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template slot="item" slot-scope="props">
                                    <tr :data-id="props.item.SpeciesID">
                                        <td>{{props.item.SpeciesCode}}</td>
                                        <td>{{props.item.SpeciesName}}</td>
                                        <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                        <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                        <td v-if="!auth.currentUserIsReadOnly()">
                                            <v-btn
                                                color="warning"
                                                block
                                                @click="editSpecies(props.item)"
                                            >
                                                Edit
                                            </v-btn>
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </template>
                                <template v-if="!loading" slot="no-data">
                                    <v-alert v-if="loadError" outlined :value="true" color="error" icon="error">
                                        {{loadError}}
                                    </v-alert>
                                    <v-alert v-if="!loadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        
        <v-dialog v-model="showEditDialog" transition="dialog-bottom-transition" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="saving" @click="cancelEditSpecies">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="editedSpecies && editedSpecies.SpeciesID">Edit Species</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Species</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="editSpeciesValid">
                    <v-row class="dialog-content">
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="100"
                                        maxlength="100"
                                        v-model="editedSpecies.SpeciesCode"
                                        :rules="[rules.required]"
                                        label="Species Code">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        clearable
                                        counter="100"
                                        maxlength="100"
                                        v-model="editedSpecies.SpeciesName"
                                        :rules="[rules.required]"
                                        label="Tag Color">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox label="Active" v-model="editedSpecies.Active"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="6">
                                    <v-btn block color="error" :disabled="saving" @click="cancelEditSpecies">Cancel</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-btn block color="success" :disabled="!editSpeciesValid" :loading="saving" @click="saveEditedSpecies">Save</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="saveError">
                                    <v-alert text type="error">{{ saveError }}</v-alert>
                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import * as auth from '@/services/auth';

export default {
    components: {
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth,
            activeOnly: true,
            editedSpecies: {},
            showEditDialog: false,
            editSpeciesValid: false,
            rules: validationRules.rules,
            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "Date",
                descending: true,
                page: 1
            },
            headers: [
                {
                    text: "Species Code",
                    value: "SpeciesCode"
                },
                {
                    text: "Tag Color",
                    value: "SpeciesName"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false,
                    width: "100px"
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.speciesStore.loading;
        },
        loadError() {
            return this.$store.state.speciesStore.loadError;
        },
        saving() {
            return this.$store.state.speciesStore.saving;
        },
        saveError() {
            return this.$store.state.speciesStore.saveError;
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active || !this.activeOnly);
        }
    },
    methods: {
        loadSpecies() {
            this.$store.dispatch("speciesStore/loadSpecies");
        },
        editSpecies(item) {
            this.$store.dispatch("speciesStore/clearSaveError");

            this.editedSpecies = Object.assign({}, item);

            this.showEditDialog = true;

            // show which fields are mandatory when opening the edit form
            this.$nextTick(() => this.$refs.editForm.validate());
        },
        cancelEditSpecies() {
            this.showEditDialog = false;
            this.editedSpecies = {};
        },
        saveEditedSpecies() {
            var that = this;

            this.$store.dispatch("speciesStore/saveSpecies", {
                species: this.editedSpecies,
                finally: function() {
                    if (that.$store.state.speciesStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditSpecies();
                    }
                }
            });
        }
    },
    created() {
        this.loadSpecies();
    }
};
</script>

<style>
    
</style>